import { UrlConfig } from 'config';
import { JSONObject } from 'models/Api/types';
import { ApiResponse } from 'models/Api/ApiResponse';
import { AjaxService } from 'services';
import { ProcessStatus } from 'models/types';
import { ListingDataSuggestionModel, PaginationModel } from 'models';
import { RawListingDataSuggestion } from 'models/ListingDataSuggestion/types';
import { RawPaginationData } from 'models/Pagination/Pagination';

export class ListingDataSuggestionApiClient {
  public static async createListingDataSuggestion(listingId: string, data: JSONObject): Promise<string> {
    const url = UrlConfig.LISTING_DATA_SUGGESTION.LISTING_DATA_SUGGESTION_CREATE;
    const response: ApiResponse<string> = await AjaxService.postData(url, {
      listing_id: listingId,
      data: data
    });
    return response.data;
  }

  public static async getDetailedStatusSuggestions(
    status: ProcessStatus,
    page?: number,
    perPage?: number
  ): Promise<PaginationModel<ListingDataSuggestionModel>> {
    const params = new URLSearchParams();
    if (page != null) params.set('page', String(page));
    if (perPage != null) params.set('per_page', String(perPage));
    const query = params.toString();
    const url =
      UrlConfig.LISTING_DATA_SUGGESTION.LISTING_DATA_SUGGESTION_DETAILED_STATUS +
      `${status}` +
      (query ? `?${query}` : '');
    const response: ApiResponse<RawPaginationData<RawListingDataSuggestion>> = await AjaxService.getData(url);
    const paginatedResponse: PaginationModel<RawListingDataSuggestion> = new PaginationModel(response.data);
    const formattedSuggestions = paginatedResponse.data.map((rawSuggestion: RawListingDataSuggestion) => new ListingDataSuggestionModel(rawSuggestion));
    const formattedPaginatedResponse: PaginationModel<ListingDataSuggestionModel> = new PaginationModel({ ...response.data, data: formattedSuggestions, fetched: true });
    return formattedPaginatedResponse;
  }

  public static async approveSuggestion(payload: { listing_data_suggestion_id: string }): Promise<string> {
    const url = UrlConfig.LISTING_DATA_SUGGESTION.LISTING_DATA_SUGGESTION_APPROVE;
    const id = payload.listing_data_suggestion_id;
    await AjaxService.postData(url, payload);
    return id;
  }

  public static async rejectSuggestion(payload: { listing_data_suggestion_id: string }): Promise<string> {
    const url = UrlConfig.LISTING_DATA_SUGGESTION.LISTING_DATA_SUGGESTION_REJECT;
    const id = payload.listing_data_suggestion_id;
    await AjaxService.postData(url, payload);
    return id;
  }
}
